import { useCallback, useEffect, useMemo, useState } from 'react';

export const NewReturnFulfillmentId = 'new';
export const NewEnhancedReturnIdPrefix = `${NewReturnFulfillmentId}-`;

export const usePendingReturn = (selectedReturnId) => {
  const [hasPendingReturn, setHasPendingReturn] = useState(false);

  const isPendingReturnSelected = selectedReturnId?.startsWith(NewReturnFulfillmentId) || false;

  // If the user selects the pending return, we know they must be in the process of creating a return
  // However, we still want to let them select other shipments/returns and still persist the `hasPending` state, until
  // the user cancels it
  useEffect(() => {
    if (isPendingReturnSelected) {
      setHasPendingReturn(true);
    }
  }, [isPendingReturnSelected]);

  const resetHasPendingReturn = useCallback(() => {
    setHasPendingReturn(false);
  }, []);

  return useMemo(() => {
    return {
      hasPendingReturn,
      isPendingReturnSelected,
      resetHasPendingReturn,
    };
  }, [resetHasPendingReturn, hasPendingReturn, isPendingReturnSelected]);
};
